import ServiceBase from '../../services/ServiceBase';
import strategyProxy from '../../proxies/strategy/FiinTradeStrategyProxy';

class StrategyService extends ServiceBase {
  getValue(params) {
    return this.applyMemoryCache('getValue', params)(() =>
      strategyProxy.getValue(params),
    );
  }

  getMomentum(params) {
    return this.applyMemoryCache('getMomentum', params)(() =>
      strategyProxy.getMomentum(params),
    );
  }

  getGrowth(params) {
    return this.applyMemoryCache('getGrowth', params)(() =>
      strategyProxy.getGrowth(params),
    );
  }

  getVGM(params) {
    return this.applyMemoryCache('getVGM', params)(() =>
      strategyProxy.getVGM(params),
    );
  }

  getLeaders(params) {
    return this.applyMemoryCache('getLeaders', params)(() =>
      strategyProxy.getLeaders(params),
    );
  }

  getValueInvestment(params) {
    return this.applyMemoryCache('getValueInvestment', params)(() =>
      strategyProxy.getValueInvestment(params),
    );
  }

  getOverView(params) {
    return this.applyMemoryCache('getOverView', params)(() =>
      strategyProxy.getOverView(params),
    );
  }

  getCanSlim(params) {
    return this.applyMemoryCache('getCanSlim', params)(() =>
      strategyProxy.getCanSlim(params),
    );
  }

  downloadScore(params) {
    return this.applyMemoryCache('downloadScore', params)(() =>
      strategyProxy.downloadScore(params),
    );
  }

  downloadCanSlim(params) {
    return this.applyMemoryCache('downloadCanSlim', params)(() =>
      strategyProxy.downloadCanSlim(params),
    );
  }
}

const strategyService = new StrategyService();
export default strategyService;
